import { getOwaTxpStrings } from 'owa-strings/owa-txp-strings';
import createTxpStringFormatters from './createTxpStringFormatters';
import OwaTxpStringDefinitions from '../../store/schema/OwaTxpStringDefinitions';
import OwaCoreTxpStrings from 'owa-txp/lib/store/schema/OwaCoreTxpStrings';

export default function createTxpStrings(): OwaCoreTxpStrings {
    const localizedStrings = getOwaTxpStrings();
    let txpStringDefinitions = {} as OwaTxpStringDefinitions;

    Object.getOwnPropertyNames(localizedStrings).forEach(property => {
        txpStringDefinitions[property] = localizedStrings[property];
    });

    const txpStrings: OwaCoreTxpStrings = {
        strings: txpStringDefinitions,
        formatters: createTxpStringFormatters(),
    };

    return txpStrings;
}
